export const state = () => ({
    backgrounds: {
        desktop: '',
        mobile: '',
    },
    termAndConditions: {},
    settings: {},
    vipTiers: [],
    commonTier: {},
})
export const actions = {
    async getVipBackgrounds({ commit }, params) {
        await this.$axios
            .get('/player-management/vip-system/settings/bg', { params })
            .then((data) => {
                commit('setBackgrounds', data?.data?.landing_bg)
                return true
            })
            .catch((_) => {
                return false
            })
    },
    async updateVipBackgrounds({ _ }, body) {
        const response = await this.$axios
            .put('/player-management/vip-system/settings/bg', body, {
                params: {},
            })
            .then((data) => {
                return data.data
            })
            .catch((_) => {
                return false
            })
        return response
    },
    async getTermAndConditions({ commit }, params) {
        await this.$axios
            .get('/player-management/vip-system/settings/tnc', { params })
            .then((data) => {
                commit('setTermAndConditions', data?.data?.tnc)
                return true
            })
            .catch((_) => {
                return false
            })
    },
    async updateTermAndConditions({ _ }, body) {
        const response = await this.$axios
            .put('/player-management/vip-system/settings/tnc', body, {
                params: {},
            })
            .then((data) => {
                return data.data
            })
            .catch((_) => {
                return false
            })
        return response
    },
    async getSettings({ commit }, params) {
        await this.$axios
            .get('/player-management/vip-system/settings/tier', { params })
            .then((data) => {
                commit('setSettings', data?.data)
                return true
            })
            .catch((_) => {
                return false
            })
    },
    async getVipTiers({ commit }, params) {
        await this.$axios
            .get('/player-management/vip-system/tiers', { params })
            .then((data) => {
                commit('setVipTiers', data?.data?.data)
                return true
            })
            .catch((_) => {
                return false
            })
    },

    async updateVipSystemStatus({ _ }, body) {
        const response = await this.$axios
            .put('/player-management/vip-system', body)
            .then((data) => {
                return true
            })
            .catch((_) => {
                return false
            })
        return response
    },
    async updateVipSystemTiers({ _ }, body) {
        const response = await this.$axios
            .put('/player-management/vip-system/tiers', body)
            .then((data) => {
                return true
            })
            .catch((_) => {
                return false
            })
        return response
    },
    async getCommonTiers({ commit }, params) {
        const response = await this.$axios
            .get('/player-management/vip-system/tiers/common', { params })
            .then((data) => {
                commit('setCommonTier', data?.data?.common_tier)
                return true
            })
            .catch((_) => {
                return false
            })
        return response
    },
    async updateCommonTier({ _ }, body) {
        const response = await this.$axios
            .put('/player-management/vip-system/tiers/common', body)
            .then((data) => {
                return true
            })
            .catch((_) => {
                return false
            })
        return response
    },
}
export const mutations = {
    setBackgrounds(state, payload) {
        state.backgrounds = payload
    },
    setTermAndConditions(state, payload) {
        state.termAndConditions = payload
    },
    setSettings(state, payload) {
        state.settings = payload
    },
    setVipTiers(state, payload) {
        state.vipTiers = payload
    },
    setCommonTier(state, data) {
        state.commonTier = data || {}
    },
}
